module.exports = __webpack_public_path__ + "static/media/rm.f41ee027.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/rm.gif
// module id = 428
// module chunks = 0